import type { VehicleSummary } from 'domain/vehicle';
import { formatDate, formatTime, getDateFromString } from 'helper/time';

export const getVehicleTypeName = (vehicle: VehicleSummary): string => {
    if (vehicle.type === 'SIMULATOR') return 'Simulated agents';
    if (vehicle.type === 'DUMMY') return 'End to End Test';

    if (vehicle.type === 'TRATON') {
        switch (vehicle.subtype) {
            case 'PHYSICAL_VEHICLE':
                return 'Physical Vehicle';
            case 'SIMULATED_VEHICLE_WITH_CONNECTIVITY':
                return 'Simulated Vehicle with Connectivity';
            case 'HW_RIG':
                return 'HW Rig';
        }
    }

    return 'Unknown';
};

export const isVehicleStale = (vehicle: VehicleSummary, days = 30): boolean => {
    const threshold = Date.now() - days * 24 * 60 * 60 * 1000;

    const vehicleConnectivity = vehicle.connectivity?.value;

    if (vehicleConnectivity?.value?.state === 'ONLINE') return false;

    const lastConnectedTime = new Date(vehicleConnectivity?.updatedAt ?? '').getTime();
    if (!Number.isNaN(lastConnectedTime)) return lastConnectedTime <= threshold;

    const createdTime = new Date(vehicle.createdAt ?? '').getTime();
    if (!Number.isNaN(createdTime) && createdTime > threshold) return false;

    return true;
};

export const formatDateTimeWithDash = (date?: string) => {
    const parsed = getDateFromString(date);
    return parsed ? `${formatTime(parsed)} - ${formatDate(parsed)}` : '';
};
